import {
  ColumnData,
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../assetRouteContext';
import { RoutineAllColumn } from './asset-routines-all-column';
import { AssetRoutinesHeader } from './asset-routines-header';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutinesAll = () => {
  const { assetId = '', issueId } = useParams();
  const navigate = useNavigate();
  const [count, setCount] = useState<number>();

  if (!assetId) {
    return null;
  }

  const leftColumn: ColumnData = {
    title: 'assets.menu.title',
    mainComponent: (
      <AssetRouteProvider value={{
        basePath: issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`,
        listPath: issueId ? '/activities' : '/assets',
        isWorkspaceMode: false,
        issueId,
      }}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ),
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => navigate(issueId ? '../../../..' : '../..', { relative: 'path' }),
    disableScroll: true,
  };

  const rightColumn: ColumnData = {
    title: 'assets.routines',
    count,
    mainComponent: (
      <RoutineAllColumn assetId={assetId} onItemsCountChange={setCount} />
    ),
    showBackButton: true,
    headerComponent: <AssetRoutinesHeader assetId={assetId} issueId={issueId} />,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => navigate('../..', { relative: 'path' }),
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
